var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.66671L0.88419 4.18031C0.658956 4.23394 0.5 4.43518 0.5 4.66671H1ZM8 3.00005L8.11581 2.51365C8.03967 2.49552 7.96033 2.49552 7.88419 2.51365L8 3.00005ZM1 22H0.5C0.5 22.153 0.570035 22.2975 0.690085 22.3924C0.810135 22.4872 0.966988 22.5218 1.11581 22.4864L1 22ZM15 22L14.8842 22.4864C14.9603 22.5045 15.0397 22.5045 15.1158 22.4864L15 22ZM22 3H22.5C22.5 2.84702 22.43 2.70245 22.3099 2.60763C22.1899 2.51281 22.033 2.47816 21.8842 2.5136L22 3ZM22 20.3333L22.1158 20.8197C22.341 20.7661 22.5 20.5648 22.5 20.3333H22ZM7.5 6.91176C7.5 7.18791 7.72386 7.41176 8 7.41176C8.27614 7.41176 8.5 7.18791 8.5 6.91176H7.5ZM8.5 18.5C8.5 18.2239 8.27614 18 8 18C7.72386 18 7.5 18.2239 7.5 18.5H8.5ZM15.5 20C15.5 19.7239 15.2761 19.5 15 19.5C14.7239 19.5 14.5 19.7239 14.5 20H15.5ZM14.5 6C14.5 6.27614 14.7239 6.5 15 6.5C15.2761 6.5 15.5 6.27614 15.5 6H14.5ZM1.11581 5.15311L8.11581 3.48645L7.88419 2.51365L0.88419 4.18031L1.11581 5.15311ZM7.88419 19.8469L0.88419 21.5136L1.11581 22.4864L8.11581 20.8197L7.88419 19.8469ZM1.5 22V4.66671H0.5V22H1.5ZM15.1158 4.18027L8.11581 2.51365L7.88419 3.48645L14.8842 5.15307L15.1158 4.18027ZM7.88419 20.8197L14.8842 22.4864L15.1158 21.5136L8.11581 19.8469L7.88419 20.8197ZM15.1158 5.15307L22.1158 3.4864L21.8842 2.5136L14.8842 4.18027L15.1158 5.15307ZM21.5 3V20.3333H22.5V3H21.5ZM21.8842 19.8469L14.8842 21.5136L15.1158 22.4864L22.1158 20.8197L21.8842 19.8469ZM7.5 3.00005V6.91176H8.5V3.00005H7.5ZM7.5 18.5V20.3333H8.5V18.5H7.5ZM15.5 22V20H14.5V22H15.5ZM15.5 6V4.66667H14.5V6H15.5Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13C19 11.7113 15.866 9 12 9C8.13401 9 5 11.7113 5 13",
    stroke: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13C5 14.1895 8.13401 17 12 17C15.866 17 19 14.1895 19 13",
    stroke: "#ffffff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 1.5,
    stroke: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.fdcc4f0ccd1dc234c305bc82520cac4e.svg";
export { ForwardRef as ReactComponent };